import { useState, useContext } from 'react';
import { AppConfigContext } from '../context';
import { PublicKey } from '@solana/web3.js';
import { AirdropChecker } from '../rest/kairos/types';

export const useChecker = () => {
    const { apiUrl } = useContext(AppConfigContext);
    const [checker, setChecker] = useState<AirdropChecker | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const fetchTokens = async (wallet: PublicKey | null) => {
        if (!wallet) {
            setChecker(null);
            setIsLoading(false);
            setError("Wallet not connected");
            return;
        }

        setIsLoading(true);
        setError(null);
        try {
            const response = await fetch(`${apiUrl}/airdrop/checker?wallet=${wallet.toBase58()}`);
            const data = await response.json();
            if (data) {
                if (data.error) {
                    setError(data.error);
                    setChecker(null);
                    return;
                } else {
                    const checkerData: AirdropChecker = data;
                    setChecker(checkerData);
                }
            }
        } catch (err) {
            console.error("Error fetching Airdrop Checker:", err);
            setChecker(null);
            setError("Error fetching Airdrop Checker");
        } finally {
            setIsLoading(false);
        }
    };

    return { checker, isLoading, error, fetchTokens };
};
